/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClientInfo } from './ClientInfo';
import {
    ClientInfoFromJSON,
    ClientInfoFromJSONTyped,
    ClientInfoToJSON,
} from './ClientInfo';
import type { BrokerInfo } from './BrokerInfo';
import {
    BrokerInfoFromJSON,
    BrokerInfoFromJSONTyped,
    BrokerInfoToJSON,
} from './BrokerInfo';

/**
 * 
 * @export
 * @interface ClientBrokerDetailsResponse
 */
export interface ClientBrokerDetailsResponse {
    /**
     * 
     * @type {string}
     * @memberof ClientBrokerDetailsResponse
     */
    claimNumber: string;
    /**
     * 
     * @type {ClientInfo}
     * @memberof ClientBrokerDetailsResponse
     */
    primaryClient: ClientInfo;
    /**
     * 
     * @type {string}
     * @memberof ClientBrokerDetailsResponse
     */
    insuredContact: string | null;
    /**
     * 
     * @type {BrokerInfo}
     * @memberof ClientBrokerDetailsResponse
     */
    broker: BrokerInfo | null;
    /**
     * 
     * @type {Array<ClientInfo>}
     * @memberof ClientBrokerDetailsResponse
     */
    additionalClients: Array<ClientInfo> | null;
}

/**
 * Check if a given object implements the ClientBrokerDetailsResponse interface.
 */
export function instanceOfClientBrokerDetailsResponse(value: object): value is ClientBrokerDetailsResponse {
    if (!('claimNumber' in value) || value['claimNumber'] === undefined) return false;
    if (!('primaryClient' in value) || value['primaryClient'] === undefined) return false;
    if (!('insuredContact' in value) || value['insuredContact'] === undefined) return false;
    if (!('broker' in value) || value['broker'] === undefined) return false;
    if (!('additionalClients' in value) || value['additionalClients'] === undefined) return false;
    return true;
}

export function ClientBrokerDetailsResponseFromJSON(json: any): ClientBrokerDetailsResponse {
    return ClientBrokerDetailsResponseFromJSONTyped(json, false);
}

export function ClientBrokerDetailsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientBrokerDetailsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'claimNumber': json['claimNumber'],
        'primaryClient': ClientInfoFromJSON(json['primaryClient']),
        'insuredContact': json['insuredContact'],
        'broker': BrokerInfoFromJSON(json['broker']),
        'additionalClients': (json['additionalClients'] == null ? null : (json['additionalClients'] as Array<any>).map(ClientInfoFromJSON)),
    };
}

export function ClientBrokerDetailsResponseToJSON(value?: ClientBrokerDetailsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'claimNumber': value['claimNumber'],
        'primaryClient': ClientInfoToJSON(value['primaryClient']),
        'insuredContact': value['insuredContact'],
        'broker': BrokerInfoToJSON(value['broker']),
        'additionalClients': (value['additionalClients'] == null ? null : (value['additionalClients'] as Array<any>).map(ClientInfoToJSON)),
    };
}

